import { useLocation, useNavigate } from 'react-router-dom';

const useRedirectWithFormId = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const handleRedirect = (data: any) => {
    if (data?.form_id === 'otp' || data?.form_id === 'login_totp') {
      navigate(`${lang}/authorization/otp`, {
        state: {
          path_url: data?.path_url,
          phone: data?.phone,
          business_key: data?.business_key,
          form_id: data?.form_id,
          tab: data.tab,
          timer: data?.timer,
        },
      });
    }

    if (data?.form_id === 'asan_wait') {
      navigate(`${lang}/authorization/confirm-asan-imza`, {
        state: {
          business_key: data?.business_key,
          verification_code: data?.verification_code,
          timer: data?.timer,
        },
      });
    }

    if (data?.form_id === 'get_company') {
      navigate(`${lang}/company-login`, {
        state: {
          path_url: data?.path_url,
          companies: data?.companies,
          business_key: data?.business_key,
          tab: data.tab,
        },
      });
    }

    if (data?.form_id === 'documents_list') {
      navigate(`${lang}/document-sign`, {
        state: {
          documents: data?.documents,
          path_url: data?.path_url,
          business_key: data?.business_key,
        },
      });
    }

    if (data?.form_id === 'recovery_email') {
      navigate(`${lang}/recovery`, {
        state: {
          business_key: data?.business_key,
          path_url: data?.path_url,
          email: data?.email,
        },
      });
    }

    if (data?.form_id === 'recovery_email_info') {
      navigate(`${lang}/recovery/link-sent`, { state: { business_key: data?.business_key, path_url: data?.path_url } });
    }

    if (data?.form_id === 'set_password') {
      navigate(`${lang}/new-password`, { state: { path_url: data?.path_url, business_key: data?.business_key } });
    }

    if (data?.form_id === 'done') {
      window.open(`${data?.base_url}${data?.print_forms[0].fileLink}`, '_blank');
    }

    if (data?.form_id === 'homepage') {
      navigate(`${lang}/home-page`, {
        state: {
          accounts_list: data?.accounts_list,
          business_key: data?.business_key,
          mailbox_unread: data?.mailbox_unread,
          main_menu: data?.main_menu,
          pending_count: data?.pending_count,
          rates: data?.rates,
          refresh_token: data?.refresh_token,
          transactions: data?.transactions,
          user: data?.user,
        },
      });
    }
  };

  return { handleRedirect };
};

export default useRedirectWithFormId;
